/**
 * Replace placeholders in a given string with styled replacements.
 * @param {string} text - The original text containing placeholders.
 * @param {Object} replacements - An object where keys are placeholders and values are the replacement text.
 * @param {Function} effect - A function that applies the desired effect to the replacement text.
 * @returns {string} - The updated string with replacements.
 */

export function replacePlaceholdersWithEffect(
  text,
  replacements,
  color,
  fontWeight
) {
  // Replace all placeholders in the text with the corresponding styled replacements
  let formattedMessage = text;
  Object.keys(replacements).forEach((key) => {
    const value = replacements[key];

    formattedMessage = formattedMessage?.replace(
      new RegExp(`{${key}}`, 'g'),
      `<span style="color: ${color}; font-weight: ${fontWeight};">${value}</span>`
    );
  });
  return formattedMessage;
}
